import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import LegalDoc from "../legalDoc/legalDoc";

const COMPANY_NAME = "Sin Fila";
const CONTACT_EMAIL = "hola@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

const fill = (text = "") =>
	text.replace("{{COMPANY_NAME}}", COMPANY_NAME).replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL);

/* Pull p1, p2, … off a section in order. */
const paragraphs = (section) =>
	Object.keys(section || {})
		.filter((key) => /^p\d+$/.test(key))
		.sort((a, b) => Number(a.slice(1)) - Number(b.slice(1)))
		.map((key) => fill(section[key]));

const Privacy = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language].privacy;

	const sections = [
		{
			id: "information-we-collect",
			heading: t.infoCollect.heading,
			groups: [
				{ subheading: t.infoCollect.provided, list: t.infoCollect.providedList },
				{ subheading: t.infoCollect.automatic, list: t.infoCollect.automaticList },
				{ subheading: t.infoCollect.thirdParty, list: t.infoCollect.thirdPartyList },
			],
		},
		{ id: "how-we-use", heading: t.howWeUse.heading, list: t.howWeUse.list },
		{ id: "sharing", heading: t.sharing.heading, list: t.sharing.list, closing: [t.sharing.noSell] },
		{ id: "cookies", heading: t.cookies.heading, paragraphs: [t.cookies.text] },
		{ id: "security", heading: t.security.heading, paragraphs: [t.security.text] },
		{ id: "retention", heading: t.retention.heading, paragraphs: [t.retention.text] },
		{ id: "international", heading: t.international.heading, paragraphs: [t.international.text] },
		{ id: "minors", heading: t.minors.heading, paragraphs: paragraphs(t.minors) },
		{ id: "user-content", heading: t.userContent.heading, paragraphs: paragraphs(t.userContent) },
		{ id: "platform-liability", heading: t.platform.heading, paragraphs: paragraphs(t.platform) },
		{ id: "your-rights", heading: t.rights.heading, list: t.rights.list, footnote: fill(t.rights.contact) },
		{ id: "changes", heading: t.changes.heading, paragraphs: [t.changes.text] },
		{ id: "contact", heading: t.contact.heading, footnote: fill(t.contact.text) },
	];

	return (
		<LegalDoc
			title={t.title}
			lastUpdatedLabel={t.lastUpdated}
			lastUpdatedValue={LAST_UPDATED}
			intro={paragraphs(t.intro)}
			sections={sections}
		/>
	);
};

export default Privacy;
